import type { TypographyColors } from '../../../../tokens/colors/types';
import { neutral } from './palette';

export const typography: TypographyColors = {
  title: neutral[100],
  body: {
    1: neutral[70],
    2: neutral[70],
  },
  disabled: neutral[50],
};
